import { memo } from "react";

import { SettingsSiteControllerBaseSiteControllerType } from "./site-controller-type";

import type { SiteControllerSettingBaseFormModel } from "../../../../model/base/type";
import type { SiteControllerSettingBaseFormModelMethodsType } from "../../../../model/base/use-case/use-create-model/methods";

type Props = {
	hotelID: string;
	siteControllerType: SiteControllerSettingBaseFormModel["ViewModel"]["siteControllerType"]; //
	siteControllerSettingBaseFormModelMethods: SiteControllerSettingBaseFormModelMethodsType;
};

export const SettingsSiteControllerBase = memo(
	({
		hotelID,
		siteControllerType,
		siteControllerSettingBaseFormModelMethods, //
	}: Props) => {
		return (
			<SettingsSiteControllerBaseSiteControllerType
				hotelID={hotelID}
				siteControllerType={siteControllerType}
				onSetSiteControllerType={
					siteControllerSettingBaseFormModelMethods.siteControllerSettingBaseFormModelMethods
						.onSetSiteControllerType
				}
			/>
		);
	},
);

SettingsSiteControllerBase.displayName = "SettingsSiteControllerBase";
